import type { PersonalizedTasksStatus } from '@change-corgi/middle-end-gql-schema';

import type { StarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';

import { PERSONALIZED_TASKS_GENERATION_STATUSES } from '../../constants';
import type { DynamicTaskData, DynamicTaskShape } from '../../types';

type PersonalizedTasksResponse = StarterDashboardV2PageData['petition']['personalizedTasks'];

export function parsePersonalizedTasks(personalizedTasks: PersonalizedTasksResponse): {
	generationStatus: PersonalizedTasksStatus;
	tasks: readonly DynamicTaskData[];
} {
	if (personalizedTasks.__typename === 'PersonalizedTasksSuccess') {
		return {
			generationStatus: personalizedTasks.status,
			tasks: personalizedTasks.tasks,
		};
	}
	return { generationStatus: PERSONALIZED_TASKS_GENERATION_STATUSES.FAILED, tasks: [] };
}

function getFirstActiveTaskIndex(tasks: readonly DynamicTaskData[]): number {
	return tasks.findIndex((task) => task.status === 'ACTIVE');
}

function toDynamicTaskShape(task: DynamicTaskData, index: number, firstActiveTaskIndex: number): DynamicTaskShape {
	return {
		...task,
		index,
		isFirstActive: index === firstActiveTaskIndex,
	};
}

export function buildTaskShapes(tasks: readonly DynamicTaskData[]): readonly DynamicTaskShape[] {
	const firstActiveTaskIndex = getFirstActiveTaskIndex(tasks);
	const shapes = tasks.map((task, index) => toDynamicTaskShape(task, index, firstActiveTaskIndex));
	return [...shapes].sort((a, b) => {
		const aCompleted = a.status === 'COMPLETED' ? 1 : 0;
		const bCompleted = b.status === 'COMPLETED' ? 1 : 0;
		return aCompleted - bCompleted;
	});
}

export function getDisplayedTasks(tasks: readonly DynamicTaskShape[], count: number): readonly DynamicTaskShape[] {
	return tasks.slice(0, count);
}

export function getTaskStats(tasks: readonly DynamicTaskShape[]): Readonly<{ completed: number; count: number }> {
	const completed = tasks.filter((task) => task.status === 'COMPLETED').length;
	return { completed, count: tasks.length };
}
